import React, { ReactNode } from 'react';
import { Chip, SxProps, useTheme } from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { computeComponentColors, resolveColorMain } from '../../../hooks/useThemeContrastColor';

type HexColor = string;

export type InformationChipProps = {
    label: ReactNode;
    color?: string | HexColor;
    icon?: IconProp;
    sx?: SxProps;
    sxIcon?: SxProps;
};

export const InformationChip: React.FunctionComponent<InformationChipProps> = function ({
    label,
    icon,
    color = 'primary',
    sx = undefined,
    sxIcon = undefined,
}) {
    const { palette } = useTheme();
    const token =
        palette.chip?.[color] ??
        computeComponentColors(resolveColorMain(color, palette), palette.mode);
    const { glassyStyle, glassyStyleOnHover, textColor, textColorOnHover } = token;

    return (
        <Chip
            data-testid="InformationChip-test-id"
            label={label}
            {...(icon && {
                icon: (
                    <FaOptionIcon
                        data-testid="InformationChip-icon-test-id"
                        icon={icon}
                        sx={{
                            fontSize: '0.7em',
                            paddingLeft: '7px',
                            display: 'inline-block',
                            ...sxIcon,
                        }}
                    />
                ),
            })}
            sx={{
                fontFamily: 'Inter',
                fontWeight: '400',
                fontSize: '14px',
                borderRadius: '8px',
                ...glassyStyle,
                color: textColor,
                padding: '16px 7px',
                transition: 'all ease-in-out 300ms',
                '&:hover': {
                    ...glassyStyleOnHover,
                    color: textColorOnHover,
                },
                ...sx,
            }}
        />
    );
};
